module.exports = __webpack_public_path__ + "static/animat-pencil-e32f8087cc4ed58bb27243c5c248f6bc.gif";